import React from 'react';
import { scrollToSection } from '../utils/smoothScroll';

/**
 * Footer Component
 * Enhanced footer with brand info and quick links
 */

const Footer: React.FC = () => {
  const handleSocialClick = () => {
    window.open('https://www.instagram.com/siyaramjewellers4736', '_blank', 'noopener,noreferrer');
  };

  const quickLinks = [
    { label: 'Home', sectionId: 'hero' },
    { label: 'About Us', sectionId: 'about' },
    { label: 'Collection', sectionId: 'collections' },
    { label: 'Gallery', sectionId: 'gallery' },
    { label: 'Rates', sectionId: 'rates' },
    { label: 'Why Us', sectionId: 'why-us' },
    { label: 'Contact', sectionId: 'contact' },
  ];

  return (
    <footer className="bg-black border-t border-gray-800">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-8">
          {/* Column 1 - Brand Info */}
          <div className="max-w-md">
            <div className="flex items-center mb-4">
              <img 
                src="/Logo.png" 
                alt="Siyaram Jewellers" 
                className="h-15"
                style={{ height: '60px', width: 'auto' }}
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Redefining luxury and trust in jewellery for over 50 years. Visit us for the 
              purest gold and finest diamonds.
            </p>
            {/* Social Media Icons */}
            <div className="flex space-x-4">
              <button
                onClick={handleSocialClick}
                className="w-10 h-10 bg-gray-800 hover:bg-yellow-500 rounded-full flex items-center justify-center text-gray-400 hover:text-black transition-all duration-300"
                aria-label="Visit our Instagram page"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </button>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="md:ml-auto">
            <h3 className="text-white font-bold text-lg mb-4 uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.sectionId}>
                  <button
                    onClick={() => scrollToSection(link.sectionId)}
                    className="text-gray-400 hover:text-yellow-500 transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-6">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} Siyaram Jewellers. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
